if (PJQ.app.module === PJQ.constants.modules.REPORTS) {
	PJQ.app.attachReadyEvent(function () {
		initSystemReports();
	});
}